<template>
  <div>
    <j-abm name="account" avatar="apple" :suppliers="suppliers" :features="{
      detail: false,
      search: true,
      create: true,
      update: true,
      delete: false,
    }">

      <template #dropdown>
        <a-dropdown-button type="primary" size="large" :trigger="['click']">
          {{ $t('msg.account.create') }}
          <a-menu slot="overlay">
            <a-menu-item @click="exporting = true">
              <a-icon type="cloud-download" class="text-secondary" />
              {{ $t('msg.account.export.title') }}
            </a-menu-item>
            <a-menu-item @click="importing = true">
              <a-icon type="cloud-upload" class="text-secondary" />
              {{ $t('msg.account.import.title') }}
            </a-menu-item>
          </a-menu>
          <a-icon slot="icon" type="down" />
        </a-dropdown-button>
      </template>
      <!-- Item -->
      <template #row="{ item }">
        <div>
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-6">
                <h5>
                  <!-- Activation -->
                  <a-tooltip :title="$t(`enum.activation.${item.activation}`)" placement="left">
                    <a-badge :status="activation[item.activation].color" />
                  </a-tooltip>
                  <!-- Name -->
                  {{ item.contact.name }}
                </h5>
                <!-- Account ID -->
                <j-label icon="number">
                  {{ item.id }} |
                  <span :style="{ color: getPlanColor(item.plan), fontWeight: 'bold' }">
                    {{ item.plan }}
                  </span>
                </j-label>
                <j-label icon="user" v-if="item.user.email">
                  {{ item.user.email }}
                </j-label>
              </div>
              <div class="col-12 col-md-6">
                <!-- Email -->
                <j-label icon="mail">
                  <j-email :value="item.contact.email" />
                </j-label>
                <!-- Phone -->
                <j-label icon="phone">
                  <j-phone :value="item.contact.mobile || item.contact.phone" />
                </j-label>
                <!-- Identification -->
                <j-label icon="idcard">
                  {{ item.contact.identification }}
                </j-label>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div>
        </div>
      </template>
      <!-- Actions -->
      <template #actions="{ item }">
        <j-actions type="icon" :item="item" />
      </template>
    </j-abm>
    <j-export :show="exporting" @close="exporting = false" />
    <j-import :show="importing" @close="importing = false" />
  </div>
</template>

<script>
import lms from '@/api/lms'
import acl from '@/auth/acl'
import { activation } from '@/utils/styles'
import JAbm from '@/views/shared/abm/search'
import JLabel from '@/views/shared/labels/text'
import JEmail from '@/views/shared/labels/email'
import JPhone from '@/views/shared/labels/phone'
import JActions from './actions'
import JExport from './export'
import JImport from './import'
export default {
  components: {
    JAbm,
    JLabel,
    JEmail,
    JPhone,
    JActions,
    JExport,
    JImport,
  },
  data: function () {
    return {
      acl,
      activation,
      exporting: false,
      importing: false,
    }
  },
  computed: {
    suppliers() {
      return {
        search: query => lms.account.searchWithRelations(query),
        fetchAll: page => lms.account.fetchAllWithRelations(page),
      }
    },
  },
  methods: {
    getPlanColor(plan) {
      switch ((plan || '').toLowerCase()) {
        case 'gold': return '#FFD700'
        case 'silver': return '#C0C0C0'
        case 'bronze': return '#CD7F32'
        case 'platinum': return '#E5E4E2'
        default: return ''
      }
    },
    onExport() {
      this.$router.push('/accounts/export')
    },
  },
}
</script>
